module.exports = {"card":"Cartão","newNumber":"Número NOWO","chooseYourNumber":"Escolha o seu número NOWO","portabilityRequest":"Pedido de portabilidade","portabilityLabel":"Quero manter o meu número atual","insertTheNumberToKeep":"Insira o número a manter"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/modules/number.json
// module id = QV+e
// module chunks = 64